export default {"src":"/_next/static/media/sun_24.a64d0cd2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};